import { UserRole, UserStatus } from '../types';
import {
    ColumnFiltersState,
    SortingState,
    VisibilityState,
} from '@tanstack/react-table';
import { useState } from 'react';

export enum UserSortFieldEnum {
    FULL_NAME = 'fullName',
    EMAIL = 'email',
    ROLE = 'role',
    STATUS = 'status',
    CREATED_AT = 'createdAt',
}

export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}

export const useUsersTableData = () => {
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [sorting, setSorting] = useState<SortingState>([]);
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
    const [searchQuery, setSearchQuery] = useState("");

    // Отримуємо значення фільтрів
    const roleFilter = columnFilters.find(filter => filter.id === 'role')?.value as UserRole | "ALL" || "ALL";
    const statusFilter = columnFilters.find(filter => filter.id === 'status')?.value as UserStatus | "ALL" || "ALL";

    // Визначаємо поле та напрямок сортування
    const sortField = sorting[0]?.id as UserSortFieldEnum | undefined;
    const sortOrder = sorting[0]?.desc ? SortOrder.DESC : sorting[0] ? SortOrder.ASC : undefined;

    function handleSearch(value: string) {
        setSearchQuery(value);
        setPage(0);
    }

    function handleRoleChange(value: UserRole | "ALL") {
        setColumnFilters(prev => {
            const filtered = prev.filter(filter => filter.id !== 'role');
            if (value !== "ALL") {
                filtered.push({ id: 'role', value });
            }
            return filtered;
        });
        setPage(0);
    }

    function handleStatusChange(value: UserStatus | "ALL") {
        setColumnFilters(prev => {
            const filtered = prev.filter(filter => filter.id !== 'status');
            if (value !== "ALL") {
                filtered.push({ id: 'status', value });
            }
            return filtered;
        });
        setPage(0);
    }

    return {
        // Стан пагінації
        page,
        setPage,
        size,
        setSize,
        
        // Стан таблиці
        sorting,
        setSorting,
        columnFilters,
        setColumnFilters,
        columnVisibility,
        setColumnVisibility,
        
        // Стан фільтрів
        searchQuery,
        setSearchQuery: handleSearch,
        roleFilter,
        statusFilter,
        
        // Функції для фільтрів
        handleRoleChange,
        handleStatusChange,
        
        // Дані для сортування
        sortField,
        sortOrder,
    };
}; 